//来源类型cahrt配置
export const SENTIMENT_DISTRIBUTION = {
	'title': '',
	'xData': [],
	ySplitLineShow: false,
	ySplitAreaShow: false,
	xSplitLineShow: false,
	xSplitAreaShow: false,

	colors:['#49D26D','#EB4545'],
	legend: {
		data:[],
		left: 'center',
		top:'bottom',
		orient:'horizontal'
	},
	series: [{
		'name': '',
		'showLabel': true,
		'radius': ['40%', '60%'],
		'data': [],
		'smooth': false,
		itemStyle:{
			normal:{
				color:function(params) {
				//自定义颜色
				var colorList = [          
					'#ff5050','#4dffb8','#ff80aa','#9999ff','#ffa64d','#999999','#ff0000','#5c85d6','#4dff4d'
					];
					return colorList[params.dataIndex]
				 }
			}
		}
	}]
}



// WEBPACK FOOTER //
// ./src/components/sentiment/config/sentimentDistribution.js